import Vue from 'vue'
import moment from 'moment'
import {AsYouType} from 'libphonenumber-js'

Vue.filter('truncate', function(value, length) {
  if (value.length <= length) {
    return value
  } else {
    return value.substring(0, length) + '...'
  }
})

Vue.filter('toFormattedDatetime', function(datetime) {
  if (datetime === null) {
    return ''
  }
  return moment(datetime).format('YYYY年MM月DD日 HH:mm')
})

Vue.filter('tel', function(number) {
  return new AsYouType('JP').input(number)
})

Vue.filter('truncateByNumberOfWord', function(value, numberOfWord) {
  if (value.split(' ').length > numberOfWord) {
    const len  = value.split(' ', numberOfWord).join(' ').length
    return value.substring(0, value.length - (value.length - len)) + '...'
  }
  return value
})